module.exports = __webpack_public_path__ + "media/images/quizType-834716dcb0dedc19733fee90ac4ff37d.svg";